import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'

export enum Actions {
  RESET_REVIEWS = 'RESET_REVIEWS',
  UPSERT_REVIEWS = 'UPSERT_REVIEWS',
  UPSERT_REVIEW = 'UPSERT_REVIEW',
}

export function upsertReviews(reviews: InformalFeedbackRequest[]) {
  return {
    type: Actions.UPSERT_REVIEWS,
    payload: { reviews },
  }
}

export function resetReviews(reviews: InformalFeedbackRequest[]) {
  return {
    type: Actions.RESET_REVIEWS,
    payload: { reviews },
  }
}

export function upsertReview(review: InformalFeedbackRequest) {
  return {
    type: Actions.UPSERT_REVIEW,
    payload: { review },
  }
}
